import React, { useRef, useEffect, useState } from 'react';
import Gif from './TrustedMesoCases01.gif';
import Video from './TMCD.mp4';
import MobileVideo from './TMCM.mp4';

import './App.css';

function App() {
  const videoRef = useRef(null);
  const [hasInteracted, setHasInteracted] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  
  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 768px)');
    setIsMobile(mediaQuery.matches);

    const handleResize = (e) => {
      setIsMobile(e.matches);
    };

    mediaQuery.addEventListener('change', handleResize);
    return () => mediaQuery.removeEventListener('change', handleResize);
  }, []);

  const handleClick = () => {
    if (videoRef.current) {
      videoRef.current.play();
      setHasInteracted(true);
    }
  };

  return (
    <div onClick={handleClick} style={{ cursor: !hasInteracted ? 'pointer' : 'default' }}>
      <video 
        ref={videoRef}
        src={isMobile ? MobileVideo : Video} 
        loop 
        autoPlay
        playsInline
        controls={false}
        className="video-background"
      />
      {!hasInteracted && (
        <div className="play-prompt">
          <div className="headphone-text">🎧 Put your headphones on for the full experience!</div>
          <div className="click-text">
            Click anywhere to begin
          </div>
        </div>
      )}
    </div>
  );
}

export default App;